import http from "@/api/http";

export default {
  reOrder: (id) => {
    return http({
      url: "/order/reorder?id=" + id,
      method: "get",
    });
  },
  getCurrentOrder(pagination) {
    return http({
      url:
        "/order/current?page=" +
        pagination.page +
        "&perPage=" +
        pagination.perPage,
      method: "get",
    });
  },
  getGuestCurrentOrder: (idguest) => {
    return http({
      url: "/guest-order/current/" + idguest,
      method: "get",
    });
  },
  getUserOrders(pagination) {
    return http({
      url:
        "/order/history?page=" +
        pagination.page +
        "&perPage=" +
        pagination.perPage,
      method: "get",
    });
  },
  postOrder(_order) {
    
    return http({
      url: "/order/new-order",
      method: "post",
      data: _order,
    });
  },
  postGuestOrder(_order) {
    return http({
      url: "/guest-order/new-order",
      method: "post",
      data: _order,
    });
  },
  validateOrder(_data) {
    return http({
      url: "/webhook/validate-order",
      method: "post",
      data: _data,
    });
  },
  paymentIntentCanceled(_data) {
    return http({
      url: "/webhook/paymentIntent-canceled",
      method: "post",
      data: _data,
    });
  },
  makeUserPayment(cashPayment) {
    return http({
      url: "/order/make-payment",
      method: "post",
      data: cashPayment,
    });
  },
  makeGuestPayment(cashPayment) {
    return http({
      url: "/guest-order/make-payment",
      method: "post",
      data: cashPayment,
    });
  },
  getTrackedOrder(params){
    return http({
      url:
        "/order/last",
        method: "get",
        params:params
    });
  }
};
